import React from "react";
import { CentralIconBase, type CentralIconBaseProps } from "../CentralIconBase";
import { Path } from "react-native-svg";

export const IconArrowsShow: React.NamedExoticComponent<CentralIconBaseProps> = React.memo((props) => {
  return <CentralIconBase {...props} maskId="square-outlined-radius-0-stroke-1-IconArrowsShow"><Path d="M9 5.5L12 2.5L15 5.5" stroke="currentColor"/><Path d="M15 18.5L12 21.5L9 18.5" stroke="currentColor"/><Path d="M12 10V3" stroke="currentColor"/><Path d="M12 21V14" stroke="currentColor"/><Path d="M8.0002 8.5H2.5V15.5H8" stroke="currentColor"/><Path d="M16 8.5H21.5V15.5H16" stroke="currentColor"/></CentralIconBase>;
});

export default IconArrowsShow;
